module.exports = __webpack_public_path__ + "static/media/face-female-3.d169f6fe.jpg";